
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components

import SsapSummaryFallback from '../../components/ssap/SsapSummaryFallback';

// Action Creators

import { setPreviousData, setSsapSummaryCrashed } from '../../actions/ssap/ssapActionCreators';


class SsapSummaryErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.restoreAction = this.restoreAction.bind(this);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

     
    componentDidCatch(error, info) {
    }

    restoreAction() {
        const {
            data,
            actions: {
                setPreviousData,
                setSsapSummaryCrashed
            }
        } = this.props;

        setPreviousData(data);
        setSsapSummaryCrashed();

        this.setState({ hasError: false });
    }

    render() {
        const {
            hasError
        } = this.state;

        const {
            children,
            environment: {
                stateCode
            }
        } = this.props;

        if (hasError) {
            return (
                <SsapSummaryFallback
                    restoreAction = { this.restoreAction }
                    stateCode = { stateCode }
                />
            );
        }

        return children;
    }
}

const mapStateToProps = state => ({
    data: state.ssap.data,
    environment: state.common.environment
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        setPreviousData,
        setSsapSummaryCrashed
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SsapSummaryErrorBoundary);